'use strict';

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 * @param {string} attrExtension - customizable data-attr-value extension
 * @param {string} baseAttribute - check for baseAttribute
 * @param {string} type - check for type
 */
function processSwatchValues(attr, $productContainer, msgs, attrExtension, baseAttribute, type) {
    var dataAttr = '';
    if (attrExtension) {
        dataAttr = '-' + attrExtension;
    }

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data' + dataAttr + '-attr-value="'
            + attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            if (attr.id === 'width') {
                $productContainer.find('[data-attr="width"] .width-attribute, [data-attr="width"] .width-value').removeClass('selected');
            }

            $attrValue.addClass('selected');
            $swatchButton.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);

            if (!attrValue.selectable) {
                $attrValue.siblings('.selected-assistive-text').append(msgs.assistiveUnavailableText);
            }
            // $swatchButton.next('.display-color-name').text(attrValue.displayValue);

            if (attr.id === 'style') {
                $productContainer.find('.color-display-name').show();
                $productContainer.find('.display-color-name').text(attrValue.displayValue);
                $productContainer.find('.display-color-name').attr('data-productid', attrValue.variantID);
                $productContainer.find('.product-id-value').text(attrValue.id);

                if (window.utag_data && (!$productContainer.find('.display-color-name').hasClass('pdp-update-event-triggerd'))) {
                    var tealium = require('tealium/pages/tealium');
                    var productInfo = tealium.getProductDetails(attrValue.masterProductID);
                    productInfo.then(function (data) {
                        var prodObj = {
                            event_type: 'pdp_update',
                            page_name: window.utag_data.page_name,
                            adobe_user_flow: 'product details',
                            item_list_name: data.category_path,
                            product_name: data.product_name,
                            product_brand: data.product_brand,
                            product_unit_price: data.product_unit_price,
                            product_sku: data.product_sku,
                            product_style_number: data.product_style_number,
                            product_id: data.product_master,
                            adobe_product_id: data.adobe_product_id,
                            product_variant_id: data.product_variant_id,
                            product_master: data.product_master,
                            product_category: data.product_category,
                            product_subcategory: data.product_subcategory,
                            product_quantity: data.product_quantity,
                            product_vat: data.product_vat,
                            product_gender: data.product_gender,
                            product_color: window.tealiumProdColors,
                            product_size: data.product_size,
                            product_width: data.product_width,
                            product_line: data.product_line,
                            product_type: data.product_type,
                            ga_action: 'Update PDP',
                            ga_label: data.product_master,
                            original_product_unit_price: data.original_product_unit_price,
                            category_path: data.category_path
                        };
                        $productContainer.find('.display-color-name').addClass('pdp-update-event-triggerd');
                        tealium.triggerEvent(prodObj);
                    });
                }
            }
            $swatchButton.closest('.attribute').removeClass('error');
        } else {
            $attrValue.removeClass('selected');
            $swatchButton.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
            $swatchButton.next('.display-color-name').empty();
        }

        $attrValue.removeClass('selectable unselectable');
        $swatchButton.removeClass('selectable unselectable');
        $swatchButton.removeAttr('aria-disabled');

        if (type === 'bisn') {
            if ((baseAttribute !== 'width-value') || (baseAttribute === 'width-value' && attr.id === 'width')) {
                if (attrValue.url) {
                    $swatchButton.attr('data-url', attrValue.url);
                } else {
                    $swatchButton.removeAttr('data-url');
                }
            }

            // Hide if not selectable
            if (baseAttribute === 'style-value' || (baseAttribute === 'size-value' && attr.id === 'width')) {
                if (attrValue.selectable) {
                    $swatchButton.removeClass('d-none');
                } else {
                    $swatchButton.addClass('d-none');
                }
            }
        } else {
            if (attrValue.url) {
                $swatchButton.attr('data-url', attrValue.url);
            } else {
                $swatchButton.removeAttr('data-url');
            }
            $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
            $swatchButton.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
        }
        if (attr.id === 'size') {
            $swatchButton.attr('data-variantid', attrValue.variantID);
        }
        // removing the fully-oos-ind class from a swatch if the attribute fullyOOSInd is false
        if ($swatchButton.hasClass('fully-oos-ind') && !attrValue.fullyOOSInd) {
            $swatchButton.removeClass('fully-oos-ind');
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {string} attrExtension - customizable data-attr-value extension
 */
function processNonSwatchValues(attr, $productContainer, attrExtension) {
    var dataAttr = '';
    if (attrExtension) {
        dataAttr = '-' + attrExtension;
    }
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data' + dataAttr + '-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 * @param {string} attrExtension - customizable data-attr-value extension
 * @param {string} type - check for type
 * @param {string} baseAttribute - check for baseAttribute
 */
function updateAttributes(attrs, $productContainer, msgs, attrExtension, type, baseAttribute) {
    var isBOPISFulfillment = $('#bopisMethodRadioButton').is(':checked');
    var attrsWithSwatches = ['style', 'size', 'width', 'cup'];

    // Filter out the attributes for either online or instore
    attrs = attrs.filter(function (attribute) {
        return isBOPISFulfillment ? attribute.isStoreAttribute : !attribute.isStoreAttribute;
    });

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs, attrExtension, baseAttribute, type);
        } else {
            processNonSwatchValues(attr, $productContainer, attrExtension);
        }
    });
    $('body').trigger('selectors.complete');
}

module.exports = {
    updateAttributes: updateAttributes
};
